export enum Severity {
  Unassigned = "UNASSIGNED",
  Medium = "MEDIUM",
  High = "HIGH",
  Critical = "CRITICAL",
  Low = "LOW",
}
